const icons = {
  AddToCollection: 'AddToCollection',
  Ai: 'Ai',
  AiMetadata: 'AiMetadata',
  AltKey: 'AltKey',
  Analyze: 'Analyze',
  Annotation: 'Annotation',
  Archive: 'Archive',
  ArrowLeft: 'ArrowLeft',
  ArrowRight: 'ArrowRight',
  ArrowSmallDown: 'ArrowSmallDown',
  ArrowSmallRight: 'ArrowSmallRight',
  AssetTrashBin: 'AssetTrashBin',
  Audio: 'Audio',
  Automations: 'Automations',
  Back: 'Back',
  Bell: 'Bell',
  BellCrossed: 'BellCrossed',
  Billing: 'Billing',
  Calendar: 'Calendar',
  Camera: 'Camera',
  Card: 'Card',
  Clapper: 'Clapper',
  Clear: 'Clear',
  Clock: 'Clock',
  ClosedCaption: 'ClosedCaption',
  Cloud: 'Cloud',
  Cog: 'Cog',
  Collection: 'Collection',
  CollectionIsg: 'CollectionIsg',
  Column: 'Column',
  Comment: 'Comment',
  Copy: 'Copy',
  CornerDown: 'CornerDown',
  CrossMark: 'CrossMark',
  CrossMarkFilled: 'CrossMarkFilled',
  CrossMarkSmallFilled: 'CrossMarkSmallFilled',
  Custom: 'Custom',
  CustomAction: 'CustomAction',
  Datetime: 'Datetime',
  Discovery: 'Discovery',
  Divide: 'Divide',
  Dnd: 'Dnd',
  Download: 'Download',
  DrawArrow: 'DrawArrow',
  DrawCircle: 'DrawCircle',
  DrawGenerate: 'DrawGenerate',
  DrawLine: 'DrawLine',
  DrawPalette: 'DrawPalette',
  DrawPaletteColor: 'DrawPaletteColor',
  DrawPencil: 'DrawPencil',
  DrawRectangle: 'DrawRectangle',
  DrawRedo: 'DrawRedo',
  DrawSelectMove: 'DrawSelectMove',
  DrawText: 'DrawText',
  DrawUndo: 'DrawUndo',
  Dropdown: 'Dropdown',
  Edit: 'Edit',
  EditComment: 'EditComment',
  Enter: 'Enter',
  Erase: 'Erase',
  Error: 'Error',
  Expand: 'Expand',
  ExpandHeight: 'ExpandHeight',
  ExpandWidth: 'ExpandWidth',
  Export: 'Export',
  Eye: 'Eye',
  FaceRecognition: 'FaceRecognition',
  FastForward: 'FastForward',
  Favourite: 'Favourite',
  FavouriteFilled: 'FavouriteFilled',
  File: 'File',
  FileSetTrashBin: 'FileSetTrashBin',
  Filter: 'Filter',
  Float: 'Float',
  Fullscreen: 'Fullscreen',
  Globe: 'Globe',
  GoToPage: 'GoToPage',
  Grid: 'Grid',
  Group: 'Group',
  GroupAdd: 'GroupAdd',
  Hamburger: 'Hamburger',
  Help: 'Help',
  History: 'History',
  Iconik: 'Iconik',
  Id: 'Id',
  Image: 'Image',
  InPoint: 'InPoint',
  Index: 'Index',
  Info: 'Info',
  Integer: 'Integer',
  Invoice: 'Invoice',
  Job: 'Job',
  Key: 'Key',
  Link: 'Link',
  LinkAdd: 'LinkAdd',
  LinkCopy: 'LinkCopy',
  List: 'List',
  Lock: 'Lock',
  Logout: 'Logout',
  Mail: 'Mail',
  MailError: 'MailError',
  MailType: 'MailType',
  MenuVertical: 'MenuVertical',
  Metadata: 'Metadata',
  Minimize: 'Minimize',
  Minus: 'Minus',
  MobilePhone: 'MobilePhone',
  Move: 'Move',
  NavDown: 'NavDown',
  NavLeft: 'NavLeft',
  NavRight: 'NavRight',
  NavUp: 'NavUp',
  NotModified: 'NotModified',
  Open: 'Open',
  OutPoint: 'OutPoint',
  Pause: 'Pause',
  PauseFilled: 'PauseFilled',
  PdfDoc: 'PdfDoc',
  Permission: 'Permission',
  PersonChange: 'PersonChange',
  Pin: 'Pin',
  Placeholder: 'Placeholder',
  Play: 'Play',
  PlayFilled: 'PlayFilled',
  Playlist: 'Playlist',
  Plus: 'Plus',
  Progress: 'Progress',
  Project: 'Project',
  Proxy: 'Proxy',
  Publish: 'Publish',
  Range: 'Range',
  Reconnect: 'Reconnect',
  Refresh: 'Refresh',
  Relation: 'Relation',
  RemoveContent: 'RemoveContent',
  Reorder: 'Reorder',
  Repeat: 'Repeat',
  Reply: 'Reply',
  Request: 'Request',
  RequestedFilled: 'RequestedFilled',
  Reset: 'Reset',
  Restore: 'Restore',
  Reverse: 'Reverse',
  RoleGroups: 'RoleGroups',
  SavedSearch: 'SavedSearch',
  Search: 'Search',
  SelectAll: 'SelectAll',
  Selection: 'Selection',
  Sequence: 'Sequence',
  Share: 'Share',
  Show: 'Show',
  SignCrossed: 'SignCrossed',
  Signature: 'Signature',
  Sort: 'Sort',
  SortAsc: 'SortAsc',
  SortBy: 'SortBy',
  SortDesc: 'SortDesc',
  SoundOff: 'SoundOff',
  SoundOn: 'SoundOn',
  SplitView: 'SplitView',
  Stat: 'Stat',
  Storage: 'Storage',
  String: 'String',
  Stream: 'Video', // TODO: change to 'Stream' when icon is available
  Subclip: 'Subclip',
  Subtitle: 'Subtitle',
  Switch: 'Switch',
  Tag: 'Tag',
  Text: 'Text',
  ThumbDown: 'ThumbDown',
  ThumbDownFilled: 'ThumbDownFilled',
  ThumbMixed: 'ThumbMixed',
  ThumbMixedFilled: 'ThumbMixedFilled',
  ThumbUp: 'ThumbUp',
  ThumbUpFilled: 'ThumbUpFilled',
  Tick: 'Tick',
  TickChecked: 'TickChecked',
  TickCheckedFilled: 'TickCheckedFilled',
  TickUnchecked: 'TickUnchecked',
  TimeBasedMetadata: 'TimeBasedMetadata',
  Transcoder: 'Transcoder',
  Transcription: 'Transcription',
  Transfer: 'Transfer',
  TrashBin: 'TrashBin',
  Unlock: 'Unlock',
  UnselectAll: 'UnselectAll',
  Upload: 'Upload',
  UploadHistory: 'UploadHistory',
  User: 'User',
  UserAdd: 'UserAdd',
  Version: 'Version',
  VersionAdd: 'VersionAdd',
  Video: 'Video',
  Warning: 'Warning',
  Wave: 'Wave',
  Webhook: 'Webhook',
} as const;

export type IconType = keyof typeof icons;

const iconTypes: ReadonlySet<string> = new Set(Object.keys(icons));

export const isIconType = (value: string): value is IconType =>
  iconTypes.has(value);

// Values widened from their own literal to the whole union, so that a list
// built from several of them infers IconType rather than the first one used.
const iconsByType: Record<IconType, IconType> = icons;

export default iconsByType;
